import React, { useEffect, useState } from 'react';
import { getDownloadURL } from 'firebase/storage';
import { videoVitor, videoRaissa } from '../../firebase';
import ReactPlayer from 'react-player';

function VideoTestemonies() {
    const [videoUrls, setVideoUrls] = useState({
        video1: null,
        video2: null,
    });

    useEffect(() => {
        getDownloadURL(videoVitor)
            .then((url1) => {
                setVideoUrls((prevUrls) => ({ ...prevUrls, video1: url1 }));
            })
            .catch((error) => {
                console.error('Error getting download URL for video1:', error);
            });

        getDownloadURL(videoRaissa)
            .then((url2) => {
                setVideoUrls((prevUrls) => ({ ...prevUrls, video2: url2 }));
            })
            .catch((error) => {
                console.error('Error getting download URL for video2:', error);
            });
    }, []);

    const testimonial = [
        {
            id: 1,
            name: 'Vitor Melo',
            title: 'Programador',
            location: 'Rio de Janeiro',
            url: videoUrls.video1
        },
        {
            id: 2,
            name: 'Raissa',
            title: 'Universitária',
            location: 'Portugal',
            url: videoUrls.video2
        }
    ];

    return (
        <>
            <section className='py-16 md:py-20 lg:py-24 bg-gradient-to-br from-slate-50 via-white to-blue-50'>
                <div className='max-w-6xl mx-auto px-4 sm:px-6 md:px-8'>
                    {/* Header */}
                    <div className='text-center mb-16 md:mb-20 animate-fade-in'>
                        <h2 className='text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-5 tracking-tight'>
                            Depoimentos de Alunos
                        </h2>
                        <p className='text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed'>
                            Veja como nossos alunos transformaram seu inglês e alcançaram seus objetivos
                        </p>
                    </div>

                    {/* Video Grid */}
                    <div className='grid md:grid-cols-2 gap-8 lg:gap-10'>
                        {testimonial.map((item) => (
                            <div
                                key={item.id}
                                className='group animate-fade-in'
                                style={{ animationDelay: `${item.id * 0.1}s`, animationFillMode: 'both' }}
                            >
                                {/* Video Card */}
                                <div className='flex flex-col h-full'>
                                    <div className='relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 mb-6 bg-black'>
                                        {/* Video Player */}
                                        <div className='aspect-video bg-black relative group/player'>
                                            <ReactPlayer
                                                url={item.url}
                                                controls
                                                width="100%"
                                                height="100%"
                                                playing={false}
                                            />
                                            {/* Overlay effect on hover */}
                                            <div className='absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover/player:opacity-100 transition-opacity duration-300 pointer-events-none'></div>
                                        </div>
                                    </div>

                                    {/* Student Info */}
                                    <div className='flex flex-col flex-grow text-center'>
                                        <h3 className='text-lg md:text-xl font-semibold text-gray-900 mb-1'>
                                            {item.name}
                                        </h3>
                                        <p className='text-sm text-gray-600 mb-1 font-medium'>
                                            {item.title}
                                        </p>
                                        <p className='text-xs text-gray-500'>
                                            📍 {item.location}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Bottom CTA - Full Width */}
            <div className='bg-gradient-to-r from-purple-50 to-blue-50'>
                <div className='max-w-6xl mx-auto px-4 sm:px-6 md:px-8 py-16 md:py-24 text-center animate-fade-in-delay'>
                    <p className='text-xl md:text-2xl lg:text-3xl text-black font-semibold mb-6'>
                        Você também pode transformar seu inglês
                    </p>
                    <a
                        href='#course-cards'
                        onClick={(e) => {
                            e.preventDefault();
                            const target = document.getElementById('course-cards');
                            if (target) {
                                // Get the nav height (approximately 64px for fixed header)
                                const navHeight = 64;
                                const targetPosition = target.getBoundingClientRect().top + window.scrollY - navHeight;
                                window.scrollTo({
                                    top: targetPosition,
                                    behavior: 'smooth'
                                });
                            }
                        }}
                        className='inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-4 bg-indigo-600 text-white font-semibold rounded-xl hover:shadow-xl hover:scale-105 transition-all duration-300'
                    >
                        Explore os Cursos
                    </a>
                </div>
            </div>
        </>
    );
}

export default VideoTestemonies;